import Decimal from 'decimal.js/decimal'

export function titleCase(string) {
  return string.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  })
}

export function convertUnderscoresToSpaces(string) {
  return string.split('_').join(' ')
}

export function convertToSentenceCase(string) {
  // A naive implementation only for a single sentence. Only used for labels so this should be ok.
  if (string.includes('_')) string = convertUnderscoresToSpaces(string)
  let lc = string.toLowerCase()
  return lc[0].toUpperCase() + lc.slice(1)
}

export function formatSlugAsTitle(str) {
  return titleCase(str.split('-').join(' '))
}

export function formattedPrice(price) {
  return price
    ? new Decimal(Math.abs(price)).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
    : new Decimal(0).toFixed(2)
}

export function stringAsDecimal(string) {
  return new Decimal(string).toNumber()
}

export function uniqueArrayElements(array) {
  let uniqueArray = array.filter(function (item, i, ar) {
    return ar.indexOf(item) === i
  })
  return uniqueArray
}

export function findPrice(collection, urn) {
  let foundPrice =
    collection.length > 0 &&
    collection.find(price => {
      return price['_type'] === urn
    })
  return foundPrice
}

export function pad(n) {
  return n > 0 && n < 10 ? '0' + n : n
}

export function stringDateToIsoDateString(string_date) {
  return new Date(string_date).toISOString()
}

export function extractIdFromUrl(url) {
  return /[^/]*$/.exec(decodeURIComponent(url))[0]
}

export function pathAsArray(pathString) {
  return pathString.split(/\.|\[|\]/).filter(el => el.length !== 0)
}

export function isValidURL(str) {
  var a = document.createElement('a')
  a.href = str
  return a.host && a.host != window.location.host
}

export async function retryFetch(fetchFunction, expectedErrors = [], maxRetries = 2, delay = 1000) {
  let attempts = 0;
  while (attempts < maxRetries) {
    try {
      return await fetchFunction();
    } catch (error) {
      ++attempts;
      if (expectedErrors.includes(error.response?.status) || attempts >= maxRetries) {
        throw error;
      }
      // Pause before attempting again
      await new Promise(resolve => setTimeout(resolve, delay));
    }
  }
}
